const resource = {
    resource_identifier_in_use: 'Die API-Kennung {{indicator}} wird bereits verwendet',
};
export default Object.freeze(resource);
